// extracted by mini-css-extract-plugin
export default {"container":"_717a6fcc","info":"_7c5c5365","header":"_9b4e4eb4","imageWrap":"_e2a5d918","image":"_6f2270ec"};